export default __webpack_public_path__ + "static/media/testallyLogo.2fbb43d7.png";